<!-- 审核通过确认页面 -->
<template>
    <van-popup
        :value="value"
        position="bottom"
        round
        safe-area-inset-bottom
        :close-on-click-overlay="true"
        class="approval-successful-popup"
        @input="$emit('input', $event)"
        @click-overlay="handleDismiss"
    >
        <div class="sheet">
            <div class="icon-wrap" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6 12.5l4 4L18 8.5"
                        stroke="currentColor"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <p class="room-line">{{ roomLine }}</p>
            <h2 class="title">确认审核通过?</h2>
            <p class="desc">
                通过后客户将获得该时段的预约资格，并在开始前5分钟获得门禁权限。
            </p>
            <button
                class="btn-primary"
                type="button"
                :disabled="submitting"
                @click="handleConfirm"
            >
                确认通过
            </button>
            <button class="btn-text" type="button" @click="handleDismiss">
                返回
            </button>
        </div>
    </van-popup>
</template>

<script>

import { Toast } from 'vant'
import { isUnauthorizedError } from '@/tools/utils'
import { getApproveReservationRequest } from '@/request/api'

export default {
    name: 'approvalSuccessful',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        reservationId: {
            type: [String, Number],
            default: '',
        },
        roomName: {
            type: String,
            default: '',
        },
        floor: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: '',
        },
        timeRange: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            submitting: false,
        }
    },
    computed: {
        roomLine() {
            const name = String(this.roomName || '').trim()
            const floor = String(this.floor || '').trim()
            const roomLabel = name && floor ? `${name}(${floor})` : (name || floor)
            const parts = [roomLabel, this.date, this.timeRange].filter(Boolean)
            return parts.join(' · ') || '会议室预约'
        },
    },
    methods: {
        handleConfirm() {
            if (this.submitting) return
            const reservationId = this.reservationId
            if (reservationId == null || reservationId === '') {
                this.$toast && this.$toast('预约信息无效')
                return
            }

            this.submitting = true
            Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: 0,
            })

            getApproveReservationRequest({ reservationId })
                .then(() => {
                    this.$toast && this.$toast('审核已通过')
                    this.$emit('confirm')
                    this.$emit('input', false)
                })
                .catch((err) => {
                    if (isUnauthorizedError(err)) return
                    const msg = (err && (err.message || err.msg)) || '审核通过失败'
                    this.$toast && this.$toast(msg)
                })
                .finally(() => {
                    this.submitting = false
                    Toast.clear()
                })
        },
        handleDismiss() {
            this.$emit('cancel')
            this.$emit('input', false)
        },
    },
}
</script>

<style scoped>
.approval-successful-popup {
    background: transparent;
}

.sheet {
    padding: 0.48rem 0.4rem calc(0.28rem + env(safe-area-inset-bottom));
    background: #ffffff;
    text-align: center;
    box-sizing: border-box;
}

.icon-wrap {
    width: 0.88rem;
    height: 0.88rem;
    margin: 0 auto 0.28rem;
    border-radius: 50%;
    background: #e6f7ee;
    color: #22a55e;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-wrap svg {
    width: 0.44rem;
    height: 0.44rem;
}

.room-line {
    margin: 0 0 0.18rem;
    font-size: 0.24rem;
    line-height: 1.4;
    color: #2b7de9;
    font-weight: 500;
}

.title {
    margin: 0 0 0.16rem;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 1.35;
    color: #1e3a5f;
}

.desc {
    margin: 0 auto 0.4rem;
    max-width: 6.2rem;
    font-size: 0.24rem;
    line-height: 1.55;
    color: #8a9bb0;
}

.btn-primary {
    display: block;
    width: 100%;
    height: 0.96rem;
    border: none;
    border-radius: 0.48rem;
    background: #2b7de9;
    color: #ffffff;
    font-size: 0.32rem;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 0.12rem 0.28rem rgba(43, 125, 233, 0.28);
}

.btn-primary:active {
    background: #236dce;
}

.btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-text {
    display: block;
    width: 100%;
    margin-top: 0.2rem;
    padding: 0.16rem 0;
    border: none;
    background: transparent;
    font-size: 0.28rem;
    color: #8a9bb0;
    line-height: 1.4;
    cursor: pointer;
}

.btn-text:active {
    color: #6b7c91;
}
</style>
